import React, { useEffect, useState } from 'react';
import {
  Box, SimpleGrid, Stat, StatLabel, StatNumber, Text, Flex, Card, CardBody, Spinner,
} from '@chakra-ui/react';
import {
  PieChart, Pie, Cell, Tooltip, ResponsiveContainer, Legend,
} from 'recharts';
import axios from 'axios';

const DashboardDemolicion = () => {
  const [data, setData] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get(`${process.env.REACT_APP_API_URL || "http://127.0.0.1:5000"}/api/obras/solicitud-demolicion`)
      .then(res => setData(res.data))
      .catch(() => setData([]))
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <Spinner size="xl" color="blue.500" />;

  const total = data.length;
  const totalCosto = data.reduce((acc, item) => acc + Number(item.costo || 0), 0);

  const tipos = data.reduce((acc: any, item) => {
    const key = item.tipo || 'Desconocido';
    acc[key] = (acc[key] || 0) + 1;
    return acc;
  }, {});

  const chartData = Object.entries(tipos).map(([name, value]) => ({ name, value }));
  const colors = ['#E53E3E', '#38A169', '#3182CE', '#D69E2E'];

  return (
    <Box p={1}>
      {/* Gráfico centrado y compacto arriba */}
      <Flex justify="center" mb={6}>
        <Card w={{ base: '100%', md: '400px' }} boxShadow="none">
          <CardBody>
            <Text fontWeight="bold" mb={2} textAlign="center">
              Distribución por Tipo
            </Text>
            <ResponsiveContainer width="100%" height={180}>
              <PieChart>
                <Pie
                  data={chartData}
                  dataKey="value"
                  nameKey="name"
                  cx="50%"
                  cy="50%"
                  outerRadius={60}
                  label
                >
                  {chartData.map((entry, index) => (
                    <Cell key={index} fill={colors[index % colors.length]} />
                  ))}
                </Pie>
                <Tooltip />
                <Legend layout="horizontal" verticalAlign="bottom" align="center" />
              </PieChart>
            </ResponsiveContainer>
          </CardBody>
        </Card>
      </Flex>

      {/* Estadísticas debajo */}
      <SimpleGrid columns={{ base: 2, md: 3 }} spacing={4}>
        <Stat p={4} bg="white" borderRadius="md" boxShadow="md">
          <StatLabel>Total de Solicitudes</StatLabel>
          <StatNumber>{total}</StatNumber>
        </Stat>
        <Stat p={4} bg="white" borderRadius="md" boxShadow="md">
          <StatLabel>Total Recaudado</StatLabel>
          <StatNumber>${totalCosto.toFixed(2)}</StatNumber>
        </Stat>
        <Stat p={4} bg="white" borderRadius="md" boxShadow="md">
          <StatLabel>Tipos de Demolición</StatLabel>
          <StatNumber>{Object.keys(tipos).length}</StatNumber>
        </Stat>
      </SimpleGrid>
    </Box>
  );
};

export default DashboardDemolicion;
